import axios from 'axios';

const api = axios.create({ baseURL: '/api/', timeout: 120000 });

api.interceptors.request.use((config) => {
  try {
    const session = JSON.parse(localStorage.getItem('authUserdetails') || 'null');
    if (session?.approval_token) {
      config.headers = config.headers || {};
      config.headers['x-access-token'] = session.approval_token;
    }
  } catch (error) {
    localStorage.removeItem('authUserdetails');
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('authUserdetails');
      window.dispatchEvent(new Event('agl-review-session-expired'));
    }
    return Promise.reject(error);
  },
);

export default api;
